module.exports = __webpack_public_path__ + "img/logo.a3d47158.png";